/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HttpGetParticipantsService } from './http-get-participants.service';
import { ParticipantDTO } from 'app/core/models/participant-dto';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Participant } from 'app/core/models/participant';
import { Injectable } from '@angular/core';

@Injectable({
  	providedIn: 'root'
})

export class GetParticipantsService {

  	constructor(
		private httpGetParticipantsService: HttpGetParticipantsService
	) { }

	public obtain$(): Observable<Participant[]> {

		return this.httpGetParticipantsService.obtain$().pipe(
			map((dtos: ParticipantDTO[]) => dtos.map(dto => Participant.createFromDTO(dto))),
			catchError(err => {
				console.error('[GetParticipantsService] Error obtaining participants', err);
				return throwError(() => new Error('An error has occurred while trying to obtain the participants'));
			})
		);

	}

}